/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'confluence.error.panel.refresh.app': 'Opdater appen',
  'confluence.error.panel.reload.page': 'Genindlæs siden',
  'confluence.icon.label': 'Ikon',
  'confluence.modal.dialog.close.modal.button': 'Annuller',
  'confluence.select.required.field.message': 'Dette felt er påkrævet.',
  'confluence.text.area.required.field.message': 'Dette felt er påkrævet.',
  'confluence.textfield.validator.email': 'Indtast en gyldig e-mail.',
  'confluence.textfield.validator.number': 'Indtast et gyldigt tal',
  'confluence.textfield.validator.required.field.message': 'Dette felt er påkrævet.',
  'confluence.textfield.validator.telephone': 'Indtast et gyldigt telefonnummer.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Adgang påkrævet',
  'confluence.threeLOPrompt.modal.error.title': 'Fejl',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Samtykke-URL-adresse blev ikke fundet. Opdater siden, og prøv igen.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Samtykke-URL-adresse blev ikke fundet. Opdater siden, og prøv igen.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Tillad adgang',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Konfigurer adgang',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Godkendelse mislykkedes.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Du skal give appen adgang til Atlassian-produkter på dine vegne, før {appString} kan vises.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message-appify':
    'Du skal give appen adgang til Atlassian-apps på dine vegne, før {appString} kan vises.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} kræver yderligere adgang til din konto.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Advarsel om ekstern godkendelse',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'denne app',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Denne app',
  'confluence.user.group.unknown.user.message': 'Ukendt bruger',
  'confluence.user.picker.empty.field.error.message': 'Dette felt er påkrævet.',
  'confluence.user.unknown.user.message': 'Ukendt bruger',
  'forge-ui.form.submit-button.text': 'Send',
  'forge.modal.deprecation.message':
    'Din app {appName} bruger den forældede modale redigeringsfunktion til brugerdefinerede felter, som er i gang med at blive udfaset. Bed din systemadministrator om at opdatere appen for at bruge den indlejrede redigeringsfunktion i stedet. Kontakt appudvikleren, hvis der stadig er problemer.',
  'forge.modal.deprecation.title': 'Opdater din app',
};
